<template>
  <div class="detail-sections row" id="certification">
    <div class="detail-section column" id="certification-details">
      <CertificationDetails :certificationDetails="certification?.details" />
    </div>
    <div class="detail-section-group">
      <div class="detail-section column" id="borrower-details">
        <Borrower :borrower="certification?.borrowers?.borrower" />
      </div>
      <div class="detail-section column" id="borrower-details">
        <Borrower
          :borrower="certification?.borrowers?.coBorrower"
          :coborrowerDisplayName="
            certification?.borrowers?.coborrowerDisplayName
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CertificationDetails from "@/components/v2/certifications/CertificationDetails.vue";
import Borrower from "@/components/v2/certifications/Borrower.vue";
import { CertificationVM } from "@/types/certifications";

const props = defineProps<{ certification?: CertificationVM }>();
</script>

<style scoped>
.detail-sections {
  background: #f2f3f5;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 0 16px;
}

.column {
  flex: 1;
}

#certification-details {
  max-width: calc(100% / 3);
}

.detail-section-group {
  display: flex;
  width: calc(100% - calc(100% / 3));
  gap: 18px;
}

.detail-section-group > div {
  width: 50%;
}

@media screen and (max-width: 1200px) {
  #borrower-details {
    max-width: 50%;
  }
  #certification-details {
    width: 100%;
  }

  .detail-section-group {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
  }
}

@media (max-width: 960px) {
  .row {
    gap: 0;
    flex-direction: column;
  }
}

@media (max-width: 620px) {
  .summary-section {
    width: 100%;
  }
  .detail-section-group > div {
    width: 100%;
  }
  #borrower-details {
    max-width: 100%;
  }

  #certification-details {
    max-width: 100%;
  }
}
</style>
